import { Button, Text, VStack } from '@chakra-ui/react';

type Props = {
  title: string;
  description: string;
  onClick: () => void;
  buttonText: string;
};

export const NoTableContent = ({ title, description, onClick, buttonText }: Props): JSX.Element => {
  return (
    <VStack gap="l" align="center" justify="center" py="50px" width="100%">
      <VStack gap="10px" align="center" width="100%">
        <Text textStyle="body.m.medium" color="text.tertiary" textAlign="center">
          {title}
        </Text>
        <Text textStyle="body.s.regular" color="text.tertiary" textAlign="center">
          {description}
        </Text>
      </VStack>
      <Button
        onClick={onClick}
        variant="secondaryOutline"
        size="l"
        px="15px"
        py="xs"
        borderRadius="m"
        borderColor="border.accent"
        color="text.primary"
        _hover={{
          bg: 'background.canvas',
        }}
      >
        {buttonText}
      </Button>
    </VStack>
  );
};
